import { useEffect, useState } from 'react';
import { useMeetingStore } from '@/lib/meeting-store';
import { Calendar } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { MeetingForm } from '@/components/meetings/meeting-form';
import { MeetingList } from '@/components/meetings/meeting-list';

export function MeetingsPage() {
  const { meetings, isLoading, fetchMeetings } = useMeetingStore();
  const [showNewMeetingForm, setShowNewMeetingForm] = useState(false);

  useEffect(() => {
    fetchMeetings();
  }, [fetchMeetings]);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <Calendar className="w-6 h-6" />
          One-on-One Meetings
        </h1>
        <Button onClick={() => setShowNewMeetingForm(true)}>
          Schedule Meeting
        </Button>
      </div>

      {isLoading ? (
        <div className="text-center py-4">Loading meetings...</div>
      ) : meetings.length === 0 ? (
        <div className="text-center py-4 text-gray-500">
          No meetings scheduled yet
        </div>
      ) : (
        <MeetingList meetings={meetings} />
      )}

      <MeetingForm 
        open={showNewMeetingForm}
        onOpenChange={setShowNewMeetingForm}
        onSuccess={() => {
          fetchMeetings();
        }}
      />
    </div>
  );
}
